
export class MessageEventData {
    type: 'resize'|'pagechange'|'statuschange'|'surveycompleted'|'surveyclose'|'surveyerror'|'scroll'
    message?: IframeStatus
    scroll?: Omit<DOMRect, 'height' | 'width'> & Partial<Pick<DOMRect, 'height' | 'width'>>
}

export class IframeStatus{
    constructor(properties:Partial<IframeStatus>={}) {
        this.status = 'loading'
        this.merge(properties)
    }
    status: 'loading'|'loaded'|'completed'|'closing'|'errored'
    width:number
    height:number
    merge(properties:Partial<IframeStatus>){ Object.assign(this, properties) }
}
